import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Base_Url } from '../BaseUrl'
import logo from "../assets/images/celdon-logo.png"

function Privacypolicy() {
  let token = localStorage.getItem("token")

  const [data, setdata] = useState([])
  const headers = {
    Authorization: `Bearer ${token}`
  }

  const get = () => {
    axios.get(`${Base_Url}/static_pages`, { headers }).then((res) => {
      console.log(res.data)
      let filter = res.data.data.filter((item) => item.name == "Privacy Policy")

      setdata(filter[0])
    })
  }

  useEffect(() => {
    get()
  }, [])
  return (
    <>
      <nav class="navbar navbar-expand-lg navbar-light bg-white shadow">
        <div class="container-fluid">
          <div className="d-flex justify-center w-100">
            <a class="navbar-brand" href="#">
              <img src={logo} alt="" width={250} />
            </a>
          </div>

        </div>
      </nav>

      <section className='mt-5'>
        <div className="container">
          <div className="row align-middle justify-center">
            <div className="col-md-8">
              <div className="text-center my-3">
                <h3 style={{ fontSize: "30px" }}>{data?.name}</h3>
              </div>
              <div className="" dangerouslySetInnerHTML={{ __html: data?.content }}></div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Privacypolicy
